export const maxPossibleLikes = 9;
